import React, { useState } from 'react';
import styled from 'styled-components';
import { FaQrcode, FaListUl } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { MdOutlineCheckCircle } from "react-icons/md";
import { QRCodeCanvas } from "qrcode.react";
import { FaPrint, FaShareAlt, FaTicketAlt } from "react-icons/fa";

const GeneralTickets = () => {
    const [count, setCount] = useState(0);
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);
    const [paymentMode, setPaymentMode] = useState({ upi: false, cash: false });
    const [defaultChecked, setDefaultChecked] = useState(false);
    const [checked, setChecked] = useState(false);
    const adultPrice = 50;
    const childPrice = 30;
    const total = adults * adultPrice + children * childPrice;
    const handleIncrement = () => setCount((prev) => prev + 1);
    const handleDecrement = () => count > 0 && setCount((prev) => prev - 1);

    const handlePaymentChange = (mode) => {
        setPaymentMode((prev) => ({
            ...prev,
            [mode]: !prev[mode],
        }));
    };

    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <h4 className="fw-bold text-dark">General Tickets</h4>
                    <div className="row">
                        <div className="col-lg-4">
                            <div
                                className="card border-0 p-4 text-center"
                                style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}
                            >
                                <h6 className="fw-bold mb-3 text-dark">Entry Ticket</h6>
                                <div className="d-flex justify-content-center align-items-center add-member">
                                    {/* <button
                                        className="btn btn-sm me-2"
                                        style={{
                                            backgroundColor: count === 0 ? '#d4edda' : '#28a745',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                            opacity: count === 0 ? 0.5 : 1,
                                            cursor: count === 0 ? 'not-allowed' : 'pointer',
                                        }}
                                        onClick={handleDecrement}
                                        disabled={count === 0}
                                    >
                                        −
                                    </button> */}
                                    <button
                                        className="btn btn-sm me-2"
                                        style={{
                                            backgroundColor: count === 0 ? 'rgba(13, 110, 253, 0.15)' : '#0d6efd',
                                            color: count === 0 ? '#0d6efd' : '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                            opacity: count === 0 ? 0.5 : 1,
                                            cursor: count === 0 ? 'not-allowed' : 'pointer',
                                        }}
                                        onClick={handleDecrement}
                                        disabled={count === 0}
                                    >
                                        −
                                    </button>
                                    <span style={{ fontSize: '18px', minWidth: '20px' }}>{count}</span>
                                    {/* <button
                                        className="btn btn-sm ms-2"
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                        }}
                                        onClick={handleIncrement}
                                    >
                                        +
                                    </button> */}
                                    <button
                                        className="btn btn-sm ms-2"
                                        style={{
                                            backgroundColor: '#0d6efd', // btn-primary color
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                        }}
                                        onClick={handleIncrement}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row py-5">
                        <h5 className="fw-bold mb-3 text-dark">Generate Ticket</h5>
                        <div className="col-lg-4">
                            <select className="form-select">
                                <option value="">Select Ticket Type</option>
                                <option value="adult">Adult</option>
                                <option value="child">Child</option>
                                <option value="senior">Senior Citizen</option>
                            </select>
                        </div>
                        <div className="col-lg-4">
                            <select className="form-select">
                                <option value="">Select Sub Type</option>
                                <option value="general">General</option>
                                <option value="vip">VIP</option>
                                <option value="student">Student</option>
                            </select>
                        </div>
                        <div className="col-lg-4">
                            <select className="form-select">
                                <option value="">Select Sub Sub Type</option>
                                <option value="morning">Morning Slot</option>
                                <option value="afternoon">Afternoon Slot</option>
                                <option value="evening">Evening Slot</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="d-flex justify-content-between align-items-center mb-3 text-dark">
                                <strong>Adults (₹ {adultPrice})</strong>
                                <div className="d-flex align-items-center">
                                    {/* <button
                                        className="btn btn-sm me-2"
                                        style={{
                                            backgroundColor: adults === 0 ? '#d4edda' : '#28a745',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                            opacity: adults === 0 ? 0.5 : 1,
                                            cursor: adults === 0 ? 'not-allowed' : 'pointer',
                                        }}
                                        onClick={() => setAdults(Math.max(0, adults - 1))}
                                        disabled={adults === 0}
                                    >
                                        −
                                    </button> */}
                                    <button
                                        className="btn btn-sm me-2"
                                        style={{
                                            backgroundColor: adults === 0 ? 'rgba(13, 110, 253, 0.15)' : '#0d6efd',
                                            color: adults === 0 ? '#0d6efd' : '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                            opacity: adults === 0 ? 0.5 : 1,
                                            cursor: adults === 0 ? 'not-allowed' : 'pointer',
                                        }}
                                        onClick={() => setAdults(Math.max(0, adults - 1))}
                                        disabled={adults === 0}
                                    >
                                        −
                                    </button>
                                    <span>{adults}</span>
                                    {/* <button
                                        className="btn btn-sm ms-2"
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                        }}
                                        onClick={() => setAdults(adults + 1)}
                                    >
                                        +
                                    </button> */}
                                    <button
                                        className="btn btn-sm ms-2"
                                        style={{
                                            backgroundColor: '#0d6efd', // Bootstrap primary
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                        }}
                                        onClick={() => setAdults(adults + 1)}
                                    >
                                        +
                                    </button>

                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3 text-dark">
                                <strong>Children’s (₹ {childPrice})</strong>
                                <div className="d-flex align-items-center">
                                    {/* <button
                                        className="btn btn-sm me-2"
                                        style={{
                                            backgroundColor: children === 0 ? '#d4edda' : '#28a745',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                            opacity: children === 0 ? 0.5 : 1,
                                            cursor: children === 0 ? 'not-allowed' : 'pointer',
                                        }}
                                        onClick={() => setChildren(Math.max(0, children - 1))}
                                        disabled={children === 0}
                                    >
                                        −
                                    </button> */}
                                    <button
                                        className="btn btn-sm me-2"
                                        style={{
                                            backgroundColor: children === 0 ? 'rgba(13, 110, 253, 0.15)' : '#0d6efd', // 15% opacity for primary
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                            opacity: children === 0 ? 0.5 : 1,
                                            cursor: children === 0 ? 'not-allowed' : 'pointer',
                                        }}
                                        onClick={() => setChildren(Math.max(0, children - 1))}
                                        disabled={children === 0}
                                    >
                                        −
                                    </button>

                                    <span>{children}</span>
                                    {/* <button
                                        className="btn btn-sm ms-2"
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                        }}
                                        onClick={() => setChildren(children + 1)}
                                    >
                                        +
                                    </button> */}
                                    <button
                                        className="btn btn-sm ms-2"
                                        style={{
                                            backgroundColor: '#0d6efd', // Bootstrap btn-primary color
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '35px',
                                            height: '35px',
                                            fontSize: '18px',
                                            border: 'none',
                                        }}
                                        onClick={() => setChildren(children + 1)}
                                    >
                                        +
                                    </button>

                                </div>
                            </div>
                            <div className="mb-3">
                                <strong className="me-3 text-dark">Total</strong>
                                <span className="border rounded px-3 py-1" style={{ fontSize: '18px' }}>
                                    ₹ {total}
                                </span>
                            </div>
                            <div>
                                <strong className="d-block mb-2 text-dark">Payment Mode</strong>
                                <div className="d-flex gap-4">
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-1"
                                            checked={paymentMode.upi}
                                            onChange={() => handlePaymentChange('upi')}
                                        />
                                        UPI Or Card
                                    </label>
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-1"
                                            checked={paymentMode.cash}
                                            onChange={() => handlePaymentChange('cash')}
                                        />
                                        Cash
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="container">
                                <div className="row mb-3 align-items-center">
                                    <div className="col-lg-4 col-5">
                                        <label className="fw-bold mb-0">Customer Name</label>
                                    </div>
                                    <div className="col-lg-8 col-7">
                                        <input
                                            type="text"
                                            className="form-control py-1"
                                            defaultValue="Rohit Singh"
                                            style={{ height: "35px", fontSize: "14px" }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-lg-4 col-5">
                                        <label className="fw-bold mb-0">Mobile Number</label>
                                    </div>
                                    <div className="col-lg-8 col-7">
                                        <input
                                            type="text"
                                            className="form-control py-1"
                                            defaultValue="9876543210"
                                            style={{ height: "35px", fontSize: "14px" }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex gap-4 ps-2">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckDefault"
                                        checked={defaultChecked}
                                        onChange={(e) => setDefaultChecked(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Print Ticket
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckChecked"
                                        checked={checked}
                                        onChange={(e) => setChecked(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                        Send Ticket
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="text-center mt-4">
                            <button
                                className="btn btn-primary"

                            >
                                Generate Ticket
                            </button>
                        </div>
                    </div>
                </div>
            </div>




            <div className="container d-flex justify-content-center align-items-center py-5">
                <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
                    <h4 className="text-center mb-3 text-dark">Generate Counter Ticket</h4>
                    <p className="text-center text-muted mb-4">
                        Create new tickets for walk-in customers
                    </p>
                    <label className="form-label ">Tourist Spot</label>
                    <div className=" gap-3 mb-3">
                        <div className="position-relative w-100 mb-3">
                            <select className="form-control bg-light pe-5">
                                <option value="">Select a Tourist spot</option>
                                <option value="ACTIVE123">ACTIVE123</option>
                                <option value="ACTIVE456">ACTIVE456</option>
                                <option value="ACTIVE789">ACTIVE789</option>
                            </select>
                            <FaChevronDown
                                className="position-absolute text-muted"
                                style={{ top: "50%", right: "15px", transform: "translateY(-50%)", pointerEvents: "none" }}
                            />
                        </div>

                        <div className=' gap-3 mb-3'>
                            <div className='position-relative w-100'>
                                <div className="mb-3">
                                    <label htmlFor="peopleCount" className="form-label ">
                                        Number of People
                                    </label>
                                    <input
                                        type="number"
                                        id="peopleCount"
                                        className="form-control bg-light"
                                        min={1}
                                        placeholder="Enter number of people"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className=' gap-3 mb-3'>
                            <div className='position-relative w-100'>
                                <div className="mb-3">
                                    <label htmlFor="peopleCount" className="form-label">
                                        Customer Name
                                    </label>
                                    <input
                                        type="text"
                                        id="customerName"
                                        className="form-control bg-light"
                                        placeholder="Enter customer name"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="text-center w-100">
                            <button className="btn btn-primary">Generate Ticket</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center align-items-center" >
                <div className="card shadow-sm p-3 mb-4" style={{ maxWidth: '400px', width: '100%' }}>
                    <div className="d-flex align-items-center mb-2">
                        <FaListUl className="me-2 text-dark" />
                        <h6 className="mb-0 fw-bold text-dark">Recent Counter Tickets</h6>
                    </div>
                    <p className="text-muted small mb-3">Last 1 ticket(s) generated in this session.</p>

                    <div className="border rounded p-3 d-flex justify-content-between align-items-start">
                        <div>
                            <h6 className="mb-1 text-dark">CNT055517 - Lakeside Boat Tour</h6>
                            <p className="mb-0 text-muted small">Qty: 1 | Customer: Rohit</p>
                        </div>
                        <div className="text-end">
                            <div className="text-muted small">10:44 AM</div>
                            <FaQrcode size={20} className="mt-2 text-dark" />
                        </div>
                    </div>
                </div>
            </div>




            <div className="card shadow-sm p-4 text-center" style={{ maxWidth: "400px", margin: "0 auto" }}>
                <h5 className="text-primary fw-bold">Generate Counter Ticket</h5>
                <p className="text-muted mb-3">Create new tickets for walk-in customers.</p>

                <div className="d-flex justify-content-center">
                    <MdOutlineCheckCircle size={50} className="text-success my-3" />
                </div>

                <h6 className="text-success fw-bold mb-4">Ticket Generated Successfully!</h6>

                <div className="bg-light rounded p-3 text-start">
                    <p className="mb-1 text-muted">
                        <strong className='text-dark'>Ticket ID:</strong> CNT246742
                    </p>
                    <p className="mb-1 text-muted">
                        <strong className='text-dark'>Spot:</strong> City Museum Exhibit
                    </p>
                    <p className="mb-1 text-muted">
                        <strong className='text-dark'>Customer:</strong> Roger
                    </p>
                    <p className="mb-1 text-muted">
                        <strong className='text-dark'>Quantity:</strong> 1
                    </p>
                    <p className="mb-1 text-muted">
                        <strong className='text-dark'>Date:</strong> May 20, 2025, 10:47:26 AM
                    </p>
                    <p className="mb-3 text-muted">
                        <strong className='text-dark'>Status:</strong>{" "}
                        <span className="text-success fw-semibold">Active</span>
                    </p>

                    {/* <div className="text-center text-dark">
                        <FaQrcode size={60} />
                    </div> */}
                    <div className="text-center my-3">
                        <QRCodeCanvas
                            value="https://example.com/ticket/CNT246742" // You can pass dynamic values here
                            size={100}
                            level="H"
                            includeMargin={true}
                        />
                    </div>
                    <div className="text-center">
                        {/* Print & Share Buttons */}
                        <div className="d-flex justify-content-center gap-2 mb-3">
                            <button className="btn btn-light border d-flex align-items-center gap-2">
                                <FaPrint />
                                <span>Print</span>
                            </button>
                            <button className="btn btn-light border d-flex align-items-center gap-2">
                                <FaShareAlt />
                                <span>Share</span>
                            </button>
                        </div>


                    </div>

                </div>
                {/* Generate Another Ticket Button */}
                <button className="btn btn-primary w-100 d-flex justify-content-center align-items-center gap-2">
                    <FaTicketAlt />
                    <span>Generate Another Ticket</span>
                </button>

                {/* Footer Note */}
                <p className="text-muted small mt-2">Ticket is ready for the customer.</p>
            </div>
        </Wrapper>
    );
};

export default GeneralTickets;

const Wrapper = styled.div`
  .add-member {
    border: 1px solid #efefef;
    width: 120px;
    margin-left: auto;
    margin-right: auto;
  }

  .form-label {
    font-size: 14px;
  }

  .form-control {
    border: 1px solid #ccc;
    border-radius: 5px;
  }
`;
